// core/stores/bootSeed.ts — what a server-backed store starts with.
//
// Every store that mirrors server data used to boot from the bundled demo seed. In the
// running app that meant a member saw invented notifications, conversations and
// bookmarks until the real ones arrived, and KEPT seeing them if that request failed.
// The app now starts those stores empty and shows a loading or error state instead.
//
// The unit tests were written against the seeded stores, so under the test runner the
// seed is kept; nothing else ever sees it.
export function bootSeed<T>(seed: readonly T[]): T[] {
  return import.meta.env.MODE === 'test' ? [...seed] : [];
}
